var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9L1.11612 8.11612L0.232233 9L1.11612 9.88388L2 9ZM20.75 10.25C21.4404 10.25 22 9.69036 22 9C22 8.30964 21.4404 7.75 20.75 7.75V10.25ZM8.61612 0.616117L1.11612 8.11612L2.88388 9.88388L10.3839 2.38388L8.61612 0.616117ZM1.11612 9.88388L8.61612 17.3839L10.3839 15.6161L2.88388 8.11612L1.11612 9.88388ZM2 10.25H20.75V7.75H2V10.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.5b82b847cbf4215fb637ff53d2ead625.svg";
export { ForwardRef as ReactComponent };